<template>
  <div id="app">

    <div id="curtain" class="curtain row">
      <div id="curtain-part-1" class="curtain-part col-3">

      </div>
      <div id="curtain-part-2" class="curtain-part col-3">

      </div>
      <div id="curtain-part-3" class="curtain-part col-3">

      </div>
      <div id="curtain-part-4" class="curtain-part col-3">

      </div>
    </div>
    <div class="menu">
      <router-view name='menu'></router-view>
    </div>

    <div class="main">
      <transition :css="false" @enter="curtainUp"  @leave="curtainDown" @after-leave="$root.$emit('triggerScroll')">
        <router-view></router-view>
      </transition>
    </div>


  </div>
</template>

<script>


export default {
  name: 'app',
  data:function(){
    return {
      timeline:  new TimelineMax({ paused: true })
    }
  },
  methods:
  {
    curtainUp:function(el, done){


      this.timeline.to('#curtain-part-1', 0.2, {ease: Power2.easeOut, height:'0vh'});
      this.timeline.to('#curtain-part-2', 0.2, {ease: Power2.easeOut, height:'0vh'});
      this.timeline.to('#curtain-part-3', 0.2, {ease: Power2.easeOut, height:'0vh'});
      this.timeline.to('#curtain-part-4', 0.2, {ease: Power2.easeOut, height:'0vh'});
      this.timeline.to('#curtain', 0, {width:'0'});
      this.timeline.addCallback(done);
      this.timeline.play();

    },
    curtainDown:function(el, done){


      this.timeline.to('.curtain-part', 0, {height:'100vh'});
        this.timeline.to('#curtain', 1, {ease:Expo.easeOut, width:'100%'});


        this.timeline.addCallback(done);
        this.timeline.play();
    }
  },
  mounted:function(){



  }

}
</script>

<style>
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}
body {
  line-height: 1;
}
ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

.grecaptcha-badge {
  visibility: hidden;
}

.col-9{
  width:75%;
}

.col-6{
  width:50%;
}

.col-4{
  width:calc(100%/3);
}

.col-3{
  width:25%;
}

.row{
  display: flex;
}

*{
  box-sizing: border-box;
}

html{
  font-size: 16px;
}

body{
  font-family: 'Cormorant', serif;
  color:#222;

}

h1,h2{
  font-family: 'Cormorant', serif;

}

h2{
  font-weight: bold;
  font-size: 6rem;
}

h3{
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  text-transform: uppercase;
  color: #555;
  line-height: 2.25rem;
}

a{
  text-decoration: none;
  color: #555;
}


.curtain{
  top:0;
  left:0;
    position: fixed;
    width: 0;
    z-index: 99999;
}

.curtain-part{
  background-color: #dec8b2;
  height: 0vh;
  z-index: 99999;
}


.overlay{
  overflow: hidden;
}

@media all and (max-width: 1280px) {
  html{
    font-size: 10px;
  }
}

@media all and (max-width: 736px) {

  html{
    font-size: 9px;
  }

 .sm-hide{
   display: none;
 }

  .col-sm-12{
    width: 100%;
  }

  .col-sm-6{
    width: 50%;
  }
}

</style>
